import React from "react";
import { useParams } from "react-router-dom";

import Loading from "ui/Loading";
import PageContent from "ui/PageContent";
import SettingsNav from "ui/SettingsNav";

import EditForm from "./EditForm";
import Status from "./Status";
import { useCollectorSettingsQuery } from "./gql/Query.generated";
import TestLocalCollector from "./TestLocalCollector";

const CollectorSettings = () => {
  const { serverId } = useParams();
  const { data, loading, error } = useCollectorSettingsQuery({
    variables: { serverId },
  });

  if (loading || error) {
    return <Loading error={!!error} />;
  }

  const server = data.getServerDetails;

  return (
    <PageContent
      title="Collector Settings"
      pageCategory="servers"
      pageName="collector_settings"
      featureNav={<SettingsNav />}
    >
      <EditForm
        permittedToEditServer={server.permittedToEdit}
        server={server}
      />
      {server.usesLocalCollector && <TestLocalCollector serverId={serverId} />}
      <Status serverId={serverId} />
    </PageContent>
  );
};

export default CollectorSettings;
